import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-search-bar',
  imports: [FaIconComponent, FormsModule],
  template: `
    <div class="input-group search-input-group">
      <div class="input-group-prepend">
        <fa-icon class="input-group-text" [icon]="faSearch"></fa-icon>
      </div>
      <input
        #filterInput
        class="form-control"
        type="text"
        [placeholder]="placeholderText"
        [(ngModel)]="searchQuery"
        (keyup)="searchQueryChange.emit(filterInput.value)"
        (focus)="searchFocus.emit()"
        (blur)="searchBlur.emit()"
        [disabled]="disabled"
      />
    </div>
  `,
  styles: `
    :host {
      flex-grow: 1;

      .input-group {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        width: 100%;
      }

      &.search-input-group {
        input {
          border: solid #eee 1px;
          border-left: none;
          box-shadow: none;
          flex: 1 1 auto;
          margin-right: 15px;

          &:focus {
            outline: none;
          }
        }
      }

      .input-group-prepend {
        margin-right: -1px;
        display: flex;

        fa-icon {
          padding-left: 7.5px;
          padding-top: 7.5px;
          color: #eee;
          background-color: $white;
        }
      }

      .input-group.search-input-group {
        input {
          border: solid #eee 1px;
          border-left: none;
          box-shadow: none;
          flex: 1 1 auto;

          &:focus {
            outline: none;
          }
        }
      }
      .input-group-prepend {
        .input-group-text {
          border: solid #eee 1px;
          border-right: none;
        }
      }
    }
  `,
})
export class SearchBarComponent {
  @Input() placeholderText = 'Search within results...';
  @Input() searchQuery = '';
  @Input() disabled = false;
  @Input() disableSearch = false;
  @Output() searchQueryChange = new EventEmitter<string>();
  @Output() searchFocus = new EventEmitter();
  @Output() searchBlur = new EventEmitter();

  faSearch = faSearch;
}
